import { Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      {/* Newsletter Section */}
      <div className="border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-6 py-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <h2 className="text-2xl md:text-3xl font-semibold">
              Subscribe to our newsletter
            </h2>
            <div className="w-full md:w-auto flex items-center gap-0">
              <div className="relative flex-1 md:w-96">
                <input
                  type="email"
                  placeholder="enter your email"
                  className="w-full bg-gray-800 text-white placeholder-gray-400 px-6 py-4 rounded-l-full focus:outline-none focus:ring-2 focus:ring-[#FF6B35]"
                />
                <Mail className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
              </div>
              <button className="bg-[#FF6B35] hover:bg-[#ff5722] text-white px-8 py-4 rounded-r-full font-medium transition-colors whitespace-nowrap">
                Subscribe
              </button>
            </div>
          </div>
          <p className="text-gray-400 text-sm mt-4 text-center md:text-right">
            You will be able to unsubscribe at any time.
          </p>
        </div>
      </div>

      {/* Logo Section */}
      <div className="border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-[#FF6B35] rounded flex items-center justify-center">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-5 h-5 text-white"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
            </div>
            <span className="text-xl font-semibold">Podus Checker</span>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="max-w-7xl mx-auto px-6 py-6">
        <p className="text-gray-400 text-sm text-center">
          © 2025 Podus Checker. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
